




















import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class AppSearchBar extends Vue {
  search: string = "";
  async onUploadEvent() {
    this.$router.push("/blacklists/upload");
  }

  @Emit("onSearch")
  async onSearch() {
    return this.search;
  }
}
